module.exports = __webpack_public_path__ + "static/media/calendar2.21df6850.png";